// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 256 256%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cfilter id=%27n%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.85%27 numOctaves=%274%27 stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23n%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* StudioPro loading — light default, dark via html.dark (filevault-theme) */

.dashboard-loading-modern {
  --dl-primary: #4648d4;
  --dl-secondary: #8127cf;
  --dl-violet: #7c3aed;
  --dl-fuchsia: #c026d3;
  --dl-indigo: #4f46e5;
  --dl-accent-wedding: #8b5cf6;
  --dl-accent-birthday: #ec4899;

  --dl-bg: #f8f9ff;
  --dl-bg-line: rgba(70, 72, 212, 0.35);
  --dl-orb-violet: rgba(124, 58, 237, 0.28);
  --dl-orb-fuchsia: rgba(236, 72, 153, 0.18);
  --dl-orb-indigo: rgba(79, 70, 229, 0.16);
  --dl-grain-opacity: 0.03;

  --dl-panel-bg: rgba(255, 255, 255, 0.82);
  --dl-panel-border: rgba(70, 72, 212, 0.14);
  --dl-panel-shadow: 0 35px 60px -15px rgba(15, 23, 42, 0.18);

  --dl-title: #0b1c30;
  --dl-subtitle: #464554;
  --dl-brand: #64748b;

  --dl-icon-bg: rgba(255, 255, 255, 0.9);
  --dl-icon-border: rgba(70, 72, 212, 0.18);
  --dl-icon-color: var(--dl-primary);
  --dl-icon-shadow: 0 12px 32px rgba(70, 72, 212, 0.2);

  --dl-ring-1: rgba(70, 72, 212, 0.22);
  --dl-ring-2: rgba(156, 72, 234, 0.18);
  --dl-ring-3: rgba(148, 163, 184, 0.25);
  --dl-ring-4: rgba(70, 72, 212, 0.12);

  --dl-shimmer-track: rgba(70, 72, 212, 0.1);
  --dl-shimmer-glow: rgba(124, 58, 237, 0.35);

  --dl-chip-bg: rgba(255, 255, 255, 0.75);
  --dl-chip-border: rgba(70, 72, 212, 0.12);
  --dl-chip-text: #0b1c30;
  --dl-chip-icon: #464554;

  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  min-height: 100vh;
  background-color: var(--dl-bg);
  transition: background-color 0.25s ease;
}

html.dark .dashboard-loading-modern {
  --dl-bg: #0a0a0c;
  --dl-bg-line: rgba(167, 139, 250, 0.45);
  --dl-orb-violet: rgba(124, 58, 237, 0.55);
  --dl-orb-fuchsia: rgba(192, 38, 211, 0.4);
  --dl-orb-indigo: rgba(99, 102, 241, 0.35);
  --dl-grain-opacity: 0.04;

  --dl-panel-bg: rgba(255, 255, 255, 0.05);
  --dl-panel-border: rgba(255, 255, 255, 0.1);
  --dl-panel-shadow: 0 35px 60px -15px rgba(0, 0, 0, 0.5);

  --dl-title: #ffffff;
  --dl-subtitle: #94a3b8;
  --dl-brand: #64748b;

  --dl-icon-bg: rgba(255, 255, 255, 0.1);
  --dl-icon-border: rgba(255, 255, 255, 0.2);
  --dl-icon-color: #ffffff;
  --dl-icon-shadow: 0 12px 40px rgba(124, 58, 237, 0.2);

  --dl-ring-1: rgba(70, 72, 212, 0.2);
  --dl-ring-2: rgba(156, 72, 234, 0.2);
  --dl-ring-3: rgba(255, 255, 255, 0.1);
  --dl-ring-4: rgba(70, 72, 212, 0.1);

  --dl-shimmer-track: rgba(255, 255, 255, 0.05);
  --dl-shimmer-glow: rgba(124, 58, 237, 0.4);

  --dl-chip-bg: rgba(255, 255, 255, 0.05);
  --dl-chip-border: rgba(255, 255, 255, 0.1);
  --dl-chip-text: rgba(255, 255, 255, 0.9);
  --dl-chip-icon: rgba(255, 255, 255, 0.7);
}

/* Ambient scene */
.dl-scene {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
}

.dl-scene::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 80% 50% at 20% 0%, rgba(70, 72, 212, 0.12), transparent 55%),
    radial-gradient(ellipse 70% 45% at 85% 90%, rgba(236, 72, 153, 0.08), transparent 50%);
  animation: dl-bg-drift 14s ease-in-out infinite;
}

html.dark .dl-scene::before {
  background:
    radial-gradient(ellipse 80% 50% at 20% 0%, rgba(124, 58, 237, 0.22), transparent 55%),
    radial-gradient(ellipse 70% 45% at 85% 90%, rgba(217, 70, 239, 0.14), transparent 50%),
    radial-gradient(ellipse 50% 40% at 50% 50%, rgba(124, 58, 237, 0.06), transparent 60%);
}

.dl-scene::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--dl-bg-line), transparent);
}

@keyframes dl-bg-drift {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.92;
    transform: scale(1.02);
  }
}

/* Film grain (no external image) */
.dl-grain {
  position: fixed;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  opacity: var(--dl-grain-opacity);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

/* Floating orbs */
.dl-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.4;
  pointer-events: none;
}

.dl-orb-violet {
  width: 600px;
  height: 600px;
  top: -100px;
  left: -100px;
  background: radial-gradient(circle, var(--dl-orb-violet), transparent 70%);
  animation: dl-float-1 25s infinite ease-in-out;
}

.dl-orb-fuchsia {
  width: 500px;
  height: 500px;
  bottom: -50px;
  right: -50px;
  background: radial-gradient(circle, var(--dl-orb-fuchsia), transparent 70%);
  animation: dl-float-2 22s infinite ease-in-out;
}

.dl-orb-indigo {
  width: 700px;
  height: 700px;
  top: 40%;
  left: 30%;
  transform: translate(-50%, -50%);
  background: radial-gradient(circle, var(--dl-orb-indigo), transparent 70%);
  animation: dl-float-3 30s infinite ease-in-out;
}

@keyframes dl-float-1 {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(15vw, 15vh) scale(1.1);
  }
  66% {
    transform: translate(-10vw, 25vh) scale(0.9);
  }
}

@keyframes dl-float-2 {
  0%,
  100% {
    transform: translate(0, 0) scale(1.1);
  }
  33% {
    transform: translate(-20vw, -10vh) scale(0.9);
  }
  66% {
    transform: translate(15vw, -25vh) scale(1);
  }
}

@keyframes dl-float-3 {
  0%,
  100% {
    transform: translate(-50%, -50%) scale(0.9);
  }
  33% {
    transform: translate(calc(-50% + 25vw), calc(-50% - 5vh)) scale(1.05);
  }
  66% {
    transform: translate(calc(-50% - 15vw), calc(-50% + 15vh)) scale(1.15);
  }
}

/* Main column */
.dl-main {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 42rem;
  padding: 0 1.25rem;
}

/* Glass panel */
.dl-panel {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2rem 1.5rem;
  border-radius: 2rem;
  background: var(--dl-panel-bg);
  border: 1px solid var(--dl-panel-border);
  box-shadow: var(--dl-panel-shadow);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  opacity: 0;
  transform: translateY(30px);
  animation: dl-fade-in-up 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  transition:
    background 0.25s ease,
    border-color 0.25s ease,
    box-shadow 0.25s ease;
}

@media (min-width: 768px) {
  .dl-panel {
    padding: 3rem;
  }
}

@keyframes dl-fade-in-up {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Icon + rings */
.dl-icon-wrap {
  position: relative;
  width: 5.5rem;
  height: 5.5rem;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (min-width: 768px) {
  .dl-icon-wrap {
    width: 6.5rem;
    height: 6.5rem;
  }
}

.dl-pulse-ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 1px solid var(--dl-ring-1);
  animation: dl-ring-pulse 4s cubic-bezier(0.16, 1, 0.3, 1) infinite;
}

.dl-pulse-ring-1 {
  border-color: var(--dl-ring-1);
  animation-delay: 0s;
}

.dl-pulse-ring-2 {
  border-color: var(--dl-ring-2);
  animation-delay: 1s;
}

.dl-pulse-ring-3 {
  border-color: var(--dl-ring-3);
  animation-delay: 2s;
}

.dl-pulse-ring-4 {
  border-color: var(--dl-ring-4);
  animation-delay: 3s;
}

@keyframes dl-ring-pulse {
  0% {
    transform: scale(1);
    opacity: 0.6;
  }
  100% {
    transform: scale(2.2);
    opacity: 0;
  }
}

.dl-icon-core {
  position: relative;
  z-index: 2;
  width: 5rem;
  height: 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--dl-icon-bg);
  border: 1px solid var(--dl-icon-border);
  box-shadow: var(--dl-icon-shadow);
  animation: dl-icon-pulse 2.2s ease-in-out infinite;
  transition:
    background 0.25s ease,
    border-color 0.25s ease;
}

@media (min-width: 768px) {
  .dl-icon-core {
    width: 6rem;
    height: 6rem;
  }
}

.dl-icon {
  font-size: 2.25rem;
  color: var(--dl-icon-color);
  filter: drop-shadow(0 2px 8px rgba(70, 72, 212, 0.25));
  transition: color 0.25s ease;
}

@media (min-width: 768px) {
  .dl-icon {
    font-size: 2.75rem;
  }
}

@keyframes dl-icon-pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.92;
  }
}

/* Typography */
.dl-text {
  margin-bottom: 2rem;
}

.dl-title {
  margin: 0 0 0.25rem;
  font-family: 'Playfair Display', Georgia, serif;
  font-size: 1.75rem;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: var(--dl-title);
  transition: color 0.25s ease;
}

@media (min-width: 768px) {
  .dl-title {
    font-size: 2.25rem;
  }
}

.dl-subtitle {
  margin: 0;
  font-family: Inter, system-ui, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--dl-subtitle);
  transition: color 0.25s ease;
}

/* Shimmer progress */
.dl-progress {
  width: 100%;
  max-width: 24rem;
  margin-bottom: 2rem;
}

.dl-shimmer-bar {
  position: relative;
  height: 0.375rem;
  width: 100%;
  border-radius: 999px;
  overflow: hidden;
  background: var(--dl-shimmer-track);
  margin-bottom: 1rem;
}

.dl-shimmer-bar::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    var(--dl-shimmer-glow),
    rgba(192, 38, 211, 0.35),
    transparent
  );
  animation: dl-shimmer 2s infinite cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes dl-shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 200%;
  }
}

.dl-dots {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}

.dl-dot {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  animation: dl-dot-bounce 1.4s infinite ease-in-out both;
}

.dl-dot-1 {
  background: var(--dl-accent-wedding);
  animation-delay: -0.32s;
}

.dl-dot-2 {
  background: var(--dl-accent-birthday);
  animation-delay: -0.16s;
}

.dl-dot-3 {
  background: var(--dl-primary);
  animation-delay: 0s;
}

@keyframes dl-dot-bounce {
  0%,
  80%,
  100% {
    transform: scale(0);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Feature chips */
.dl-features {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

@media (min-width: 768px) {
  .dl-features {
    gap: 1rem;
  }
}

.dl-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 999px;
  background: var(--dl-chip-bg);
  border: 1px solid var(--dl-chip-border);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  opacity: 0;
  animation: dl-chip-fade-in 0.8s ease forwards;
  transition:
    background 0.2s ease,
    border-color 0.2s ease;
}

.dl-chip:hover {
  border-color: rgba(70, 72, 212, 0.25);
}

html.dark .dl-chip:hover {
  border-color: rgba(167, 139, 250, 0.25);
}

.dl-chip-icon {
  font-size: 0.875rem;
  color: var(--dl-chip-icon);
  flex-shrink: 0;
}

.dl-chip-label {
  font-family: Inter, system-ui, sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--dl-chip-text);
  white-space: nowrap;
}

@keyframes dl-chip-fade-in {
  to {
    opacity: 1;
  }
}

/* Brand footnote */
.dl-brand {
  margin: 2rem 0 0;
  font-family: Inter, system-ui, sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--dl-brand);
  opacity: 0.5;
  transition: color 0.25s ease;
}

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .dl-orb,
  .dl-pulse-ring,
  .dl-shimmer-bar::after,
  .dl-dot,
  .dl-panel,
  .dl-chip,
  .dl-icon-core,
  .dl-scene::before {
    animation: none !important;
  }

  .dl-panel,
  .dl-chip {
    opacity: 1 !important;
    transform: none !important;
  }

  .dl-shimmer-bar::after {
    left: 0;
    width: 100%;
    background: var(--dl-shimmer-glow);
  }

  .dl-pulse-ring {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/DashboardLoading.css"],"names":[],"mappings":"AAAA,4EAA4E;;AAE5E;EACE,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;EAC5B,6BAA6B;;EAE7B,gBAAgB;EAChB,qCAAqC;EACrC,yCAAyC;EACzC,0CAA0C;EAC1C,wCAAwC;EACxC,wBAAwB;;EAExB,wCAAwC;EACxC,0CAA0C;EAC1C,2DAA2D;;EAE3D,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;;EAEnB,sCAAsC;EACtC,yCAAyC;EACzC,kCAAkC;EAClC,oDAAoD;;EAEpD,oCAAoC;EACpC,qCAAqC;EACrC,sCAAsC;EACtC,oCAAoC;;EAEpC,0CAA0C;EAC1C,2CAA2C;;EAE3C,uCAAuC;EACvC,yCAAyC;EACzC,uBAAuB;EACvB,uBAAuB;;EAEvB,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;EACzC,wBAAwB;;EAExB,wCAAwC;EACxC,2CAA2C;EAC3C,uDAAuD;;EAEvD,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;;EAEnB,sCAAsC;EACtC,0CAA0C;EAC1C,wBAAwB;EACxB,qDAAqD;;EAErD,mCAAmC;EACnC,oCAAoC;EACpC,qCAAqC;EACrC,mCAAmC;;EAEnC,6CAA6C;EAC7C,0CAA0C;;EAE1C,uCAAuC;EACvC,0CAA0C;EAC1C,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;0FAEwF;EACxF,+CAA+C;AACjD;;AAEA;EACE;;;0FAGwF;AAC1F;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,WAAW;EACX,+EAA+E;AACjF;;AAEA;EACE;;IAEE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,gCAAgC;EAChC,yDAAqT;AACvT;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,0EAA0E;EAC1E,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,YAAY;EACZ,2EAA2E;EAC3E,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,0EAA0E;EAC1E,8CAA8C;AAChD;;AAEA;EACE;;IAEE,mCAAmC;EACrC;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;;IAEE,qCAAqC;EACvC;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE;;IAEE,2CAA2C;EAC7C;EACA;IACE,qEAAqE;EACvE;EACA;IACE,sEAAsE;EACxE;AACF;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;EACxC,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,UAAU;EACV,2BAA2B;EAC3B,oEAAoE;EACpE;;;yBAGuB;AACzB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,kEAAkE;AACpE;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,uCAAuC;EACvC,iCAAiC;EACjC,kDAAkD;EAClD;;2BAEyB;AAC3B;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,sDAAsD;EACtD,4BAA4B;AAC9B;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;;IAEE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,aAAa;EACf;AACF;;AAEA,eAAe;AACf;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,SAAS;EACT,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,YAAY;EACZ;;;;;;GAMC;EACD,8DAA8D;AAChE;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE;;;IAGE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,6BAA6B;EAC7B,uCAAuC;EACvC,2BAA2B;EAC3B,mCAAmC;EACnC,UAAU;EACV,6CAA6C;EAC7C;;0BAEwB;AAC1B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EACE;;;;;;;;IAQE,0BAA0B;EAC5B;;EAEA;;IAEE,qBAAqB;IACrB,0BAA0B;EAC5B;;EAEA;IACE,OAAO;IACP,WAAW;IACX,kCAAkC;EACpC;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* StudioPro loading — light default, dark via html.dark (filevault-theme) */\n\n.dashboard-loading-modern {\n  --dl-primary: #4648d4;\n  --dl-secondary: #8127cf;\n  --dl-violet: #7c3aed;\n  --dl-fuchsia: #c026d3;\n  --dl-indigo: #4f46e5;\n  --dl-accent-wedding: #8b5cf6;\n  --dl-accent-birthday: #ec4899;\n\n  --dl-bg: #f8f9ff;\n  --dl-bg-line: rgba(70, 72, 212, 0.35);\n  --dl-orb-violet: rgba(124, 58, 237, 0.28);\n  --dl-orb-fuchsia: rgba(236, 72, 153, 0.18);\n  --dl-orb-indigo: rgba(79, 70, 229, 0.16);\n  --dl-grain-opacity: 0.03;\n\n  --dl-panel-bg: rgba(255, 255, 255, 0.82);\n  --dl-panel-border: rgba(70, 72, 212, 0.14);\n  --dl-panel-shadow: 0 35px 60px -15px rgba(15, 23, 42, 0.18);\n\n  --dl-title: #0b1c30;\n  --dl-subtitle: #464554;\n  --dl-brand: #64748b;\n\n  --dl-icon-bg: rgba(255, 255, 255, 0.9);\n  --dl-icon-border: rgba(70, 72, 212, 0.18);\n  --dl-icon-color: var(--dl-primary);\n  --dl-icon-shadow: 0 12px 32px rgba(70, 72, 212, 0.2);\n\n  --dl-ring-1: rgba(70, 72, 212, 0.22);\n  --dl-ring-2: rgba(156, 72, 234, 0.18);\n  --dl-ring-3: rgba(148, 163, 184, 0.25);\n  --dl-ring-4: rgba(70, 72, 212, 0.12);\n\n  --dl-shimmer-track: rgba(70, 72, 212, 0.1);\n  --dl-shimmer-glow: rgba(124, 58, 237, 0.35);\n\n  --dl-chip-bg: rgba(255, 255, 255, 0.75);\n  --dl-chip-border: rgba(70, 72, 212, 0.12);\n  --dl-chip-text: #0b1c30;\n  --dl-chip-icon: #464554;\n\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  min-height: 100vh;\n  background-color: var(--dl-bg);\n  transition: background-color 0.25s ease;\n}\n\nhtml.dark .dashboard-loading-modern {\n  --dl-bg: #0a0a0c;\n  --dl-bg-line: rgba(167, 139, 250, 0.45);\n  --dl-orb-violet: rgba(124, 58, 237, 0.55);\n  --dl-orb-fuchsia: rgba(192, 38, 211, 0.4);\n  --dl-orb-indigo: rgba(99, 102, 241, 0.35);\n  --dl-grain-opacity: 0.04;\n\n  --dl-panel-bg: rgba(255, 255, 255, 0.05);\n  --dl-panel-border: rgba(255, 255, 255, 0.1);\n  --dl-panel-shadow: 0 35px 60px -15px rgba(0, 0, 0, 0.5);\n\n  --dl-title: #ffffff;\n  --dl-subtitle: #94a3b8;\n  --dl-brand: #64748b;\n\n  --dl-icon-bg: rgba(255, 255, 255, 0.1);\n  --dl-icon-border: rgba(255, 255, 255, 0.2);\n  --dl-icon-color: #ffffff;\n  --dl-icon-shadow: 0 12px 40px rgba(124, 58, 237, 0.2);\n\n  --dl-ring-1: rgba(70, 72, 212, 0.2);\n  --dl-ring-2: rgba(156, 72, 234, 0.2);\n  --dl-ring-3: rgba(255, 255, 255, 0.1);\n  --dl-ring-4: rgba(70, 72, 212, 0.1);\n\n  --dl-shimmer-track: rgba(255, 255, 255, 0.05);\n  --dl-shimmer-glow: rgba(124, 58, 237, 0.4);\n\n  --dl-chip-bg: rgba(255, 255, 255, 0.05);\n  --dl-chip-border: rgba(255, 255, 255, 0.1);\n  --dl-chip-text: rgba(255, 255, 255, 0.9);\n  --dl-chip-icon: rgba(255, 255, 255, 0.7);\n}\n\n/* Ambient scene */\n.dl-scene {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.dl-scene::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background:\n    radial-gradient(ellipse 80% 50% at 20% 0%, rgba(70, 72, 212, 0.12), transparent 55%),\n    radial-gradient(ellipse 70% 45% at 85% 90%, rgba(236, 72, 153, 0.08), transparent 50%);\n  animation: dl-bg-drift 14s ease-in-out infinite;\n}\n\nhtml.dark .dl-scene::before {\n  background:\n    radial-gradient(ellipse 80% 50% at 20% 0%, rgba(124, 58, 237, 0.22), transparent 55%),\n    radial-gradient(ellipse 70% 45% at 85% 90%, rgba(217, 70, 239, 0.14), transparent 50%),\n    radial-gradient(ellipse 50% 40% at 50% 50%, rgba(124, 58, 237, 0.06), transparent 60%);\n}\n\n.dl-scene::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, var(--dl-bg-line), transparent);\n}\n\n@keyframes dl-bg-drift {\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.92;\n    transform: scale(1.02);\n  }\n}\n\n/* Film grain (no external image) */\n.dl-grain {\n  position: fixed;\n  inset: 0;\n  z-index: 1;\n  pointer-events: none;\n  opacity: var(--dl-grain-opacity);\n  background-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\");\n}\n\n/* Floating orbs */\n.dl-orb {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(100px);\n  opacity: 0.4;\n  pointer-events: none;\n}\n\n.dl-orb-violet {\n  width: 600px;\n  height: 600px;\n  top: -100px;\n  left: -100px;\n  background: radial-gradient(circle, var(--dl-orb-violet), transparent 70%);\n  animation: dl-float-1 25s infinite ease-in-out;\n}\n\n.dl-orb-fuchsia {\n  width: 500px;\n  height: 500px;\n  bottom: -50px;\n  right: -50px;\n  background: radial-gradient(circle, var(--dl-orb-fuchsia), transparent 70%);\n  animation: dl-float-2 22s infinite ease-in-out;\n}\n\n.dl-orb-indigo {\n  width: 700px;\n  height: 700px;\n  top: 40%;\n  left: 30%;\n  transform: translate(-50%, -50%);\n  background: radial-gradient(circle, var(--dl-orb-indigo), transparent 70%);\n  animation: dl-float-3 30s infinite ease-in-out;\n}\n\n@keyframes dl-float-1 {\n  0%,\n  100% {\n    transform: translate(0, 0) scale(1);\n  }\n  33% {\n    transform: translate(15vw, 15vh) scale(1.1);\n  }\n  66% {\n    transform: translate(-10vw, 25vh) scale(0.9);\n  }\n}\n\n@keyframes dl-float-2 {\n  0%,\n  100% {\n    transform: translate(0, 0) scale(1.1);\n  }\n  33% {\n    transform: translate(-20vw, -10vh) scale(0.9);\n  }\n  66% {\n    transform: translate(15vw, -25vh) scale(1);\n  }\n}\n\n@keyframes dl-float-3 {\n  0%,\n  100% {\n    transform: translate(-50%, -50%) scale(0.9);\n  }\n  33% {\n    transform: translate(calc(-50% + 25vw), calc(-50% - 5vh)) scale(1.05);\n  }\n  66% {\n    transform: translate(calc(-50% - 15vw), calc(-50% + 15vh)) scale(1.15);\n  }\n}\n\n/* Main column */\n.dl-main {\n  position: relative;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 42rem;\n  padding: 0 1.25rem;\n}\n\n/* Glass panel */\n.dl-panel {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 2rem 1.5rem;\n  border-radius: 2rem;\n  background: var(--dl-panel-bg);\n  border: 1px solid var(--dl-panel-border);\n  box-shadow: var(--dl-panel-shadow);\n  backdrop-filter: blur(24px);\n  -webkit-backdrop-filter: blur(24px);\n  opacity: 0;\n  transform: translateY(30px);\n  animation: dl-fade-in-up 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n  transition:\n    background 0.25s ease,\n    border-color 0.25s ease,\n    box-shadow 0.25s ease;\n}\n\n@media (min-width: 768px) {\n  .dl-panel {\n    padding: 3rem;\n  }\n}\n\n@keyframes dl-fade-in-up {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Icon + rings */\n.dl-icon-wrap {\n  position: relative;\n  width: 5.5rem;\n  height: 5.5rem;\n  margin-bottom: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@media (min-width: 768px) {\n  .dl-icon-wrap {\n    width: 6.5rem;\n    height: 6.5rem;\n  }\n}\n\n.dl-pulse-ring {\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  border: 1px solid var(--dl-ring-1);\n  animation: dl-ring-pulse 4s cubic-bezier(0.16, 1, 0.3, 1) infinite;\n}\n\n.dl-pulse-ring-1 {\n  border-color: var(--dl-ring-1);\n  animation-delay: 0s;\n}\n\n.dl-pulse-ring-2 {\n  border-color: var(--dl-ring-2);\n  animation-delay: 1s;\n}\n\n.dl-pulse-ring-3 {\n  border-color: var(--dl-ring-3);\n  animation-delay: 2s;\n}\n\n.dl-pulse-ring-4 {\n  border-color: var(--dl-ring-4);\n  animation-delay: 3s;\n}\n\n@keyframes dl-ring-pulse {\n  0% {\n    transform: scale(1);\n    opacity: 0.6;\n  }\n  100% {\n    transform: scale(2.2);\n    opacity: 0;\n  }\n}\n\n.dl-icon-core {\n  position: relative;\n  z-index: 2;\n  width: 5rem;\n  height: 5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: var(--dl-icon-bg);\n  border: 1px solid var(--dl-icon-border);\n  box-shadow: var(--dl-icon-shadow);\n  animation: dl-icon-pulse 2.2s ease-in-out infinite;\n  transition:\n    background 0.25s ease,\n    border-color 0.25s ease;\n}\n\n@media (min-width: 768px) {\n  .dl-icon-core {\n    width: 6rem;\n    height: 6rem;\n  }\n}\n\n.dl-icon {\n  font-size: 2.25rem;\n  color: var(--dl-icon-color);\n  filter: drop-shadow(0 2px 8px rgba(70, 72, 212, 0.25));\n  transition: color 0.25s ease;\n}\n\n@media (min-width: 768px) {\n  .dl-icon {\n    font-size: 2.75rem;\n  }\n}\n\n@keyframes dl-icon-pulse {\n  0%,\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.05);\n    opacity: 0.92;\n  }\n}\n\n/* Typography */\n.dl-text {\n  margin-bottom: 2rem;\n}\n\n.dl-title {\n  margin: 0 0 0.25rem;\n  font-family: 'Playfair Display', Georgia, serif;\n  font-size: 1.75rem;\n  font-weight: 600;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n  color: var(--dl-title);\n  transition: color 0.25s ease;\n}\n\n@media (min-width: 768px) {\n  .dl-title {\n    font-size: 2.25rem;\n  }\n}\n\n.dl-subtitle {\n  margin: 0;\n  font-family: Inter, system-ui, sans-serif;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--dl-subtitle);\n  transition: color 0.25s ease;\n}\n\n/* Shimmer progress */\n.dl-progress {\n  width: 100%;\n  max-width: 24rem;\n  margin-bottom: 2rem;\n}\n\n.dl-shimmer-bar {\n  position: relative;\n  height: 0.375rem;\n  width: 100%;\n  border-radius: 999px;\n  overflow: hidden;\n  background: var(--dl-shimmer-track);\n  margin-bottom: 1rem;\n}\n\n.dl-shimmer-bar::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 50%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    var(--dl-shimmer-glow),\n    rgba(192, 38, 211, 0.35),\n    transparent\n  );\n  animation: dl-shimmer 2s infinite cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@keyframes dl-shimmer {\n  0% {\n    left: -100%;\n  }\n  100% {\n    left: 200%;\n  }\n}\n\n.dl-dots {\n  display: flex;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.dl-dot {\n  width: 0.5rem;\n  height: 0.5rem;\n  border-radius: 50%;\n  animation: dl-dot-bounce 1.4s infinite ease-in-out both;\n}\n\n.dl-dot-1 {\n  background: var(--dl-accent-wedding);\n  animation-delay: -0.32s;\n}\n\n.dl-dot-2 {\n  background: var(--dl-accent-birthday);\n  animation-delay: -0.16s;\n}\n\n.dl-dot-3 {\n  background: var(--dl-primary);\n  animation-delay: 0s;\n}\n\n@keyframes dl-dot-bounce {\n  0%,\n  80%,\n  100% {\n    transform: scale(0);\n    opacity: 0.5;\n  }\n  40% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* Feature chips */\n.dl-features {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n@media (min-width: 768px) {\n  .dl-features {\n    gap: 1rem;\n  }\n}\n\n.dl-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  border-radius: 999px;\n  background: var(--dl-chip-bg);\n  border: 1px solid var(--dl-chip-border);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  opacity: 0;\n  animation: dl-chip-fade-in 0.8s ease forwards;\n  transition:\n    background 0.2s ease,\n    border-color 0.2s ease;\n}\n\n.dl-chip:hover {\n  border-color: rgba(70, 72, 212, 0.25);\n}\n\nhtml.dark .dl-chip:hover {\n  border-color: rgba(167, 139, 250, 0.25);\n}\n\n.dl-chip-icon {\n  font-size: 0.875rem;\n  color: var(--dl-chip-icon);\n  flex-shrink: 0;\n}\n\n.dl-chip-label {\n  font-family: Inter, system-ui, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--dl-chip-text);\n  white-space: nowrap;\n}\n\n@keyframes dl-chip-fade-in {\n  to {\n    opacity: 1;\n  }\n}\n\n/* Brand footnote */\n.dl-brand {\n  margin: 2rem 0 0;\n  font-family: Inter, system-ui, sans-serif;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  color: var(--dl-brand);\n  opacity: 0.5;\n  transition: color 0.25s ease;\n}\n\n/* Reduced motion */\n@media (prefers-reduced-motion: reduce) {\n  .dl-orb,\n  .dl-pulse-ring,\n  .dl-shimmer-bar::after,\n  .dl-dot,\n  .dl-panel,\n  .dl-chip,\n  .dl-icon-core,\n  .dl-scene::before {\n    animation: none !important;\n  }\n\n  .dl-panel,\n  .dl-chip {\n    opacity: 1 !important;\n    transform: none !important;\n  }\n\n  .dl-shimmer-bar::after {\n    left: 0;\n    width: 100%;\n    background: var(--dl-shimmer-glow);\n  }\n\n  .dl-pulse-ring {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
